/** User seats per tier, keyed by the tier's monthly reminder limit (Basic 50 ... Premium 1000). */
export const PLAN_USER_SEATS_BY_REMINDERS_LIMIT: Readonly<Record<number, number>> = {
  50: 1,
  100: 1,
  250: 2,
  500: 5,
  1000: 10,
}

/** Currencies Paddle Classic can localize prices to. */
export const PADDLE_CURRENCY_CODES = [
  'USD',
  'EUR',
  'GBP',
  'ARS',
  'AUD',
  'BRL',
  'CAD',
  'CHF',
  'CNY',
  'CZK',
  'DKK',
  'HKD',
  'HUF',
  'ILS',
  'INR',
  'JPY',
  'KRW',
  'MXN',
  'NOK',
  'NZD',
  'PLN',
  'RUB',
  'SEK',
  'SGD',
  'THB',
  'TRY',
  'TWD',
  'UAH',
  'ZAR',
] as const

export const SUBSCRIPTION_POLL_INTERVAL_MS = 2000
export const SUBSCRIPTION_POLL_TIMEOUT_MS = 20000

export const PLAN_BUTTON_LABEL_IDS = {
  resume: 'payment.plans.button.resume',
  subscribe: 'payment.plans.button.subscribe',
  currentPlan: 'payment.plans.button.currentPlan',
  upgrade: 'payment.plans.button.upgrade',
} as const
